<template>
	<div>
		<div class="authPage__text">
			<div class="authPage__title">
				<div class="authPage__titleLine1">
					{{ $t("loginTitleLine1") }}
				</div>
				<div class="authPage__titleLine2">
					{{
						$t("loginTitleLine2", {
							brandName: brandName,
						})
					}}
				</div>
			</div>
			<div class="authPage__lead">
				{{
					$t(
						"Insira suas informações nos campos abaixo para entrar no simulador."
					)
				}}
			</div>
		</div>

		<ValidationObserver v-slot="{ handleSubmit }">
			<form
				class="authPage__form"
				@submit.prevent="handleSubmit(handleValidSubmit)"
			>
				<div
					class="o-stack"
					:style="{
						'--gap': '30px',
						'margin-bottom': '60px',
					}"
				>
					<ValidationProvider rules="required|email" v-slot="{ errors }">
						<BFieldBlock :label="$t('E-mail')">
							<BFieldText
								v-model="form.email"
								:placeholder="$t('Insira o e-mail')"
								type="email"
								:state="errors.length ? 'error' : undefined"
								:helperText="errors.length ? $t(errors[0]) : undefined"
							/>
						</BFieldBlock>
					</ValidationProvider>

					<ValidationProvider rules="required" v-slot="{ errors }">
						<BFieldBlock :label="$t('Password')">
							<BFieldText
								v-model="form.password"
								:placeholder="$t('Insira a password')"
								type="password"
								:state="errors.length ? 'error' : undefined"
								:helperText="errors.length ? $t(errors[0]) : undefined"
							>
							</BFieldText>
						</BFieldBlock>
					</ValidationProvider>

					<div class="flex align-items-center justify-between">
						<router-link class="t-link" to="/forgot-password">
							{{ $t("Recuperar password") }}
						</router-link>
					</div>
				</div>

				<div class="o-stack">
					<BBtn>
						{{ $t("Entrar") }}
					</BBtn>

					<router-link to="/register">
						<BBtn variant="text" class="u-wf">
							{{ $t("Criar Conta") }}
						</BBtn>
					</router-link>
				</div>
			</form>
		</ValidationObserver>
	</div>
</template>

<script>
import { mapActions } from "vuex";

import BBtn from "@/components/base/BBtn";
import BFieldBlock from "@/components/base/BFieldBlock";
import BFieldText from "@/components/base/BFieldText";
import BSwitch from "@/components/base/BSwitch";
import BIcon from "@/components/base/BIcon";

import branding from "@/branding";

import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
	components: {
		BBtn,
		BFieldBlock,
		BFieldText,
		BSwitch,
		BIcon,
		ValidationProvider,
		ValidationObserver,
	},
	data() {
		return {
			brandName: branding.BRAND_NAME,
			form: {
				email: "",
				password: "",
			},
		};
	},
	methods: {
		...mapActions("user", ["login"]),

		handleValidSubmit(e) {
			const { $router, $route } = this;

			this.serverFormError = null;

			this.login({
				...this.form,
			})
				.then(() => {
					$router.push($route.query.redirectTo || "/dashboard");
				})
				.catch((err) => {
					this.$notify({
						type: "error",
						title:
							err?.response?.data?.details?.[0]?.description ??
							"Erro ao fazer login. Verifique as suas credenciais.",
					});
				});
		},
	},
};
</script>
